import * as classNames from 'classnames';
import * as React from 'react';
import ChevronPanel from 'source/app/presentation/Shared/ChevronPanel/ChevronPanel';
import RPGIcon, {
	GetRPGIcon,
	GetRPGIconNames
} from 'source/app/presentation/Shared/RPGIcon/RPGIcon';
import { StyleClass } from 'source/app/presentation/Shared/Styles/CSS';
import Hyperlink from '../../Link/Hyperlink';

export function RPGIconSelector({
	OnSelect,
	currentIconName
}: {
	OnSelect: (iconName: string) => any;
	currentIconName?: string;
}) {
	const iconNames = GetRPGIconNames();

	const defaultStyleClass = StyleClass(`rpgIconSelectorIcon_default`, {
		opacity: 0.7,
		fontSize: `24px`,
		':hover': {
			opacity: 1.0
		},
		transition: `all 0.5s`
	});

	const currentIconStyleClass = StyleClass(
		`rpgIconSelectorIcon_currentIcon`,
		{
			opacity: 1.0,
			color: 'yellowgreen',
			border: '1px dotted yellowgreen',
			borderRadius: '3px'
		}
	);

	return (
		<ChevronPanel id="iconSelector" label="Select icon">
			<div style={{ marginTop: `5px` }}>
				{iconNames.map((iconName) => (
					<Hyperlink whenClicked={() => OnSelect(iconName)} key={iconName}>
						<span
							data-tip={iconName}
							className={classNames(defaultStyleClass, {
								[currentIconStyleClass]:
									iconName === currentIconName
							})}
						>
							<RPGIcon icon={GetRPGIcon(iconName)} />
						</span>
					</Hyperlink>
				))}
			</div>
		</ChevronPanel>
	);
}
